// api/products.js
import { API_BASE_URL, ADMIN_SECRET } from '../utils/constants';

export async function refreshProductsFromRemote() {
  const res = await fetch(`${API_BASE_URL}/api/admin/products/refresh`, {
    method: 'GET',
    credentials: 'include',
    headers: { 
        'Content-Type': 'application/json',
        'admin-secret': `${ADMIN_SECRET}` ,
    },
  });
  if (!res.ok) {
    let payload;
    try { payload = await res.json(); } catch { payload = await res.text(); }
    const msg = typeof payload === 'string'
      ? payload
      : payload?.error || JSON.stringify(payload);
    throw new Error(`Refresh failed: ${res.status} ${res.statusText} — ${msg}`);
  }
  return res.json();
}
